export const kuehneNagel2026 = {
  id: "kuehne-nagel-2026",
  carrierId: "kuehne-nagel",
  carrierName: "Kuehne+Nagel",
  tariffYear: 2026,
  currency: "EUR",
  vatRate: 0.19,
  volumetricWeightFactorKgPerCbm: 150,
  sourceNote:
    "Grundversion fuer Kuehne+Nagel Stueckgut Deutschland. Bitte echte Tariftabellenwerte zentral in dieser Struktur oder spaeter aus der Datenbank pflegen.",
  tariffTypes: [
    {
      id: "outbound-de",
      label: "Ausgang Deutschland",
      originCountry: "DE",
      destinationCountry: "DE",
      defaultSenderPostalCode: "94116",
      zonesByPostalPrefix: {
        "10": 7,
      },
      weightBreaksKg: [100, 200, 300, 400, 500, 600, 800, 1000, 1200, 1500, 2000, 2500, 3000],
      pricesByWeightAndZone: {
        100: { 7: null },
        200: { 7: null },
        300: { 7: null },
        400: { 7: null },
        500: { 7: null },
        600: { 7: null },
        800: { 7: null },
        1000: { 7: null },
        1200: { 7: 158.4 },
        1500: { 7: null },
        2000: { 7: null },
        2500: { 7: null },
        3000: { 7: null },
      },
    },
  ],
  packageMinimumWeightsKg: {
    euroPallet: {
      label: "Europalette / Einwegpalette",
      minimumWeightKg: 175,
    },
    cageBox: {
      label: "Gitterbox",
      minimumWeightKg: 250,
    },
    halfPallet: {
      label: "Halbpalette",
      minimumWeightKg: 90,
    },
    quarterPallet: {
      label: "Viertelpalette",
      minimumWeightKg: 60,
    },
  },
  insuranceTable: [],
  surchargeDefinitions: [
    {
      id: "diesel",
      label: "Dieselzuschlag",
      type: "percentageOfBaseFreight",
      unit: "%",
    },
    {
      id: "toll",
      label: "Maut",
      type: "fixedAmount",
      unit: "EUR",
    },
    {
      id: "notification",
      label: "Avisierung",
      type: "fixedAmount",
      unit: "EUR",
    },
    {
      id: "b2c",
      label: "B2C-Zuschlag",
      type: "fixedAmount",
      unit: "EUR",
    },
    {
      id: "palletExchange",
      label: "Tauschgebuehr Europalette",
      type: "fixedAmount",
      unit: "EUR",
    },
    {
      id: "transportInsurance",
      label: "Transportversicherung",
      type: "insuranceTable",
      unit: "EUR",
      insuranceTable: [],
    },
    {
      id: "capitalProvision",
      label: "Kapitalbereitstellungsprovision",
      type: "percentageOfSubtotal",
      defaultPercentage: 3,
      unit: "%",
    },
  ],
};


